import { render } from "./AdvisoryHome.vue?vue&type=template&id=0485678c&scoped=true"
import script from "./AdvisoryHome.vue?vue&type=script&lang=js"
export * from "./AdvisoryHome.vue?vue&type=script&lang=js"

import "./AdvisoryHome.vue?vue&type=style&index=0&id=0485678c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0485678c"]])

export default __exports__